import React, { useState } from 'react';
import { X, Search, Globe, Check } from 'lucide-react';
import './CountrySelector.css';
import { COUNTRIES } from '../../../constants/constants';

const CountrySelector = ({
  isOpen,
  onClose,
  onSelect,
  selectedCountryId = null,
  title = "Select Country"
}) => {
  const [searchTerm, setSearchTerm] = useState('');

  const countries = COUNTRIES;

  const filteredCountries = searchTerm
    ? countries.filter(country =>
      country.name.toLowerCase().includes(searchTerm.toLowerCase())
    )
    : countries;

  const handleCountrySelect = (country) => {
    onSelect(country);
    handleClose();
  };

  const handleClose = () => {
    setSearchTerm('');
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="country-selector-overlay">
      <div className="country-selector-dialog">
        <div className="country-selector-header">
          <h2>{title}</h2>
          <button className="country-selector-close" onClick={handleClose}>
            <X size={20} />
          </button>
        </div>

        <div className="country-selector-content">
          <div className="country-selector-search-container">
            <div className="country-selector-search-input-container">
              <Search size={16} className="country-selector-search-icon" />
              <input
                type="text"
                placeholder="Search countries..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="country-selector-search-input"
                autoFocus
              />
            </div>
          </div>

          <div className="country-selector-list">
            {filteredCountries.length > 0 ? (
              filteredCountries.map(country => (
                <div key={country.id} className="country-selector-item-wrapper">
                  <div
                    className={`country-selector-item ${selectedCountryId === country.id ? "selected" : ""}`}
                    onClick={() => handleCountrySelect(country)}
                  >
                    <div className="country-selector-info">
                      <div className="country-selector-name">{country.name}</div>
                      <div className="country-selector-code">{country.code}</div>
                    </div>

                    {selectedCountryId === country.id && <Check size={16} />}
                  </div>
                </div>
              ))
            ) : (
              <div className="country-selector-no-results">
                <Globe size={32} />
                <p>No countries found</p>
                <span>Try a different search term</span>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CountrySelector;
